import Organization from "./Organization";

export default class Person {
  id!: number;
  name!: string;
  email!: Array<string>;
  phone!: Array<string>;
  Organization!: Organization;
}
